import React, { useEffect, useState } from 'react';
import { ExamcompassClient } from '../Api/api';
import { Link } from 'react-router-dom';

type planType = {
  id: number;
  plan_duration: string;
  plan_package: string;
  price: string;
}

const Pricing: React.FC = () => {
  const [plans, setPlans] = useState<planType[] | null>(null);

  useEffect(() => {
    const fetchSubPackages = async () => {
      try {
        const response = await ExamcompassClient.get('/info/plans/');
        setPlans(response?.data);
      }
      catch (err) {
        console.log('Error fetching subscription packages', err);
      }
    }

    fetchSubPackages();
  }, [])


  return (
    <section id='subscribe' className=' pt-24 pb-12 relative'>
      <div className='container'>
        <div className='mb-10'>
          <div className='mb-14'>
            <h1 className='text-[30px] lg:text-[40px] text-center text-darkGreen font-medium mb-2'>
              Simple, transparent pricing
            </h1>
            <p className='text-[20px] text-center text-textColor'>
              No contracts. No surprise fees
            </p>
          </div>
        </div>

        {/* Price options */}
        <div className='flex flex-wrap justify-evenly'>
          {plans?.map((item, i) => (
            <div
              key={item?.id}
              className='w-[330px] md:w-[320px] lg:w-[370px] border-3 border-green-900 mb-20 flex justify-end relative'
            >
              <div
                className={`w-[300px] md:w-[300px] lg:w-[340px] h-[190px] md:h-[200px] px-[30px] relative ${i === 0 ? 'bg-purpleBg' : i === 1 ? 'bg-pinkBg' : 'bg-blueBg'
                  }`}
              >
                <Link to={'/register'}><p
                  className='text-[16px] text-white flex-1 items-baseline absolute bottom-2 left-3 md:bottom-6 md:left-6 cursor-pointer'
                >
                  CHOOSE PLAN
                </p></Link>
              </div>
              <div
                className={`bg-white w-[300px] md:w-[300px] lg:w-[340px] p-[10px] absolute left-0 -top-7 ${i === 0 ? 'one' : i === 1 ? 'two' : 'three'}`}
              >
                <p className='text-[36px] text-darkText mb-6'>
                  ₦{item.price}
                  <span className='text-[17px] text-textColor'>{item.plan_duration === 'annual' && 'Annually'}</span>
                </p>
                <p className='text-darkText text-[28px] mb-6'>{item.plan_package}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Pricing;